import React, { useEffect, useState } from "react";
import axios from "axios";

const TargetVsGeneratedReport = () => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [brandId, setBrandId] = useState("");

    const [brands, setBrands] = useState([]);
    const [report, setReport] = useState([]);

    const [loading, setLoading] = useState(false);
    const [generatedAt, setGeneratedAt] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        const start = params.get("start_date");
        const end = params.get("end_date");
        const brand = params.get("brand_id");

        if (start) {
            setStartDate(start);
        }

        if (end) {
            setEndDate(end);
        }

        if (brand) {
            setBrandId(brand);
        }
    }, []);

    useEffect(() => {
        if (startDate && endDate) {
            fetchReport();
        }
    }, [startDate, endDate]);

    const fetchReport = async () => {
        try {
            setLoading(true);

            const response = await axios.get(
                "/api/target-vs-generated/preview",
                {
                    params: {
                        start_date: startDate,
                        end_date: endDate,
                        brand_id: brandId || undefined,
                    },
                }
            );

            if (response.data.status) {
                setReport(response.data.data || []);
                setGeneratedAt(response.data.generated_at || "");
            } else {
                setReport([]);
            }
        } catch (error) {
            console.error("Target vs Generated Report Error:", error);

            setReport([]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">

            <div className="card">

                <div className="card-body">

                    <h4 className="mb-4">
                        Target vs Generated Report
                    </h4>

                    <div className="row mb-4">

                        <div className="col-md-3">
                            <label>From Date</label>

                            <input
                                type="date"
                                className="form-control"
                                value={startDate}
                                onChange={(e) =>
                                    setStartDate(e.target.value)
                                }
                            />
                        </div>

                        <div className="col-md-3">
                            <label>To Date</label>

                            <input
                                type="date"
                                className="form-control"
                                value={endDate}
                                onChange={(e) =>
                                    setEndDate(e.target.value)
                                }
                            />
                        </div>

                        <div className="col-md-3">
                            <label>Brand</label>

                            <select
                                className="form-control"
                                value={brandId}
                                onChange={(e) =>
                                    setBrandId(e.target.value)
                                }
                            >
                                <option value="">
                                    All Brands
                                </option>

                                {brands.map((brand) => (
                                    <option
                                        key={brand.brand_id}
                                        value={brand.brand_id}
                                    >
                                        {brand.brand_name}
                                    </option>
                                ))}

                            </select>
                        </div>

                        <div className="col-md-3 d-flex align-items-end">

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={fetchReport}
                            >
                                Preview Report
                            </button>

                        </div>

                    </div>

                    {generatedAt && (
                        <div className="mb-3 text-muted">

                            Latest data generated at:{" "}

                            <strong>
                                {generatedAt}
                            </strong>

                        </div>
                    )}

                    {loading ? (

                        <div className="text-center py-5">
                            Loading report...
                        </div>

                    ) : (

                        <div className="table-responsive">

                            <table className="table table-bordered table-striped">

                                <thead>

                                    <tr>
                                        <th>Brand</th>
                                        <th>State</th>
                                        <th>Target</th>
                                        <th>Web</th>
                                        <th>App</th>
                                        <th>FBE</th>
                                        <th>Organic</th>
                                        <th>Social</th>
                                        <th>Total Generated</th>
                                        <th>Pending</th>
                                        <th>Achievement %</th>
                                    </tr>

                                </thead>

                                <tbody>

                                    {report.length > 0 ? (

                                        report.map((row, index) => (

                                            <tr key={index}>

                                                <td>
                                                    {row.brand_name}
                                                </td>

                                                <td>
                                                    {row.state_name}
                                                </td>

                                                <td>
                                                    {row.target}
                                                </td>

                                                <td>
                                                    {row.organic_web}
                                                </td>

                                                <td>
                                                    {row.organic_app}
                                                </td>

                                                <td>
                                                    {row.organic_fbe}
                                                </td>

                                                <td>
                                                    {row.organic_generated}
                                                </td>

                                                <td>
                                                    {row.social_generated}
                                                </td>

                                                <td>
                                                    {row.total_generated}
                                                </td>

                                                <td>
                                                    {row.pending_target}
                                                </td>

                                                <td>
                                                    {row.achievement_percentage}%
                                                </td>

                                            </tr>

                                        ))

                                    ) : (

                                        <tr>

                                            <td
                                                colSpan="11"
                                                className="text-center"
                                            >
                                                No data found.
                                            </td>

                                        </tr>
                                    )}

                                </tbody>

                            </table>

                        </div>
                    )}

                </div>

            </div>

        </div>
    );
};

export default TargetVsGeneratedReport;